export type STAGES = 'development' | 'production' | 'staging';

export const stage = (process.env.REACT_APP_STAGE as STAGES) || 'development';

export const BASE_URL = process.env.REACT_APP_API_URL || '';

const bulkApiStages: Record<STAGES, string> = {
  development:
    process.env.REACT_APP_BULK_DEV_API_URL || 'https://bulk-dev.up.railway.app',
  staging: 'https://bulk-api.retrobridge.dev',
  production: 'https://bulk-api.retrobridge.io',
};

export const BULK_API_URL = bulkApiStages[stage];

const botApiStages: Record<STAGES, string> = {
  development: '',
  staging: 'https://rebalance-dev.retrobridge.dev',
  production: 'https://rebalancer-bot.retrobridge.io',
};

export const BOT_API_URL = botApiStages[stage];

const testnetApiStages: Record<STAGES, string> = {
  production: 'https://testnet.backend.retrobridge.io',
  staging: 'https://testnet.backend.retrobridge.dev',
  development: 'https://testnet.backend.retrobridge.dev',
};

export const TESTNET_API_URL = testnetApiStages[stage];
